import { CrownOutlined, EyeOutlined } from '@ant-design/icons'
import { EasyModal, EasyImg } from 'src/components'
import { Authorize, AuthInfo } from './028'
import { mainStore } from 'enasops/stores'
import { getImgBase } from 'src/utils/axios'
import { pictureThumb } from 'src/assets/base64'
import 'enasops/styles/op/028/index.less'

export default {
  authorize (ListTableContext: any, props: any) {
    const { LABEL, __RECORD__: record } = props.config
    return (
      <EasyModal
        fullModal
        modal={{ title: '应用授权' }}
        slot={
          <span title={LABEL}>
            <CrownOutlined className='fz-16' />
            <span className='pd-l4'>{LABEL}</span>
          </span>
        }
      >
        <Authorize record={record} />
      </EasyModal>
    )
  },
  view (ListTableContext: any, props: any) {
    const { LABEL, __RECORD__: record } = props.config
    return (
      <EasyModal
        fullModal
        modal={{ title: '应用浏览' }}
        slot={
          <span title={LABEL}>
            <EyeOutlined className='fz-16' />
            <span className='pd-l4'>{LABEL}</span>
          </span>
        }
      >
        <AuthInfo record={record} />
      </EasyModal>
    )
  },
  renderLogo (text: string, record: any, ListTableContext: any) {
    let files = []
    try { files = JSON.parse(text) } catch (err) { }
    return files.map((item: any) => {
      const url = `${mainStore.baseConfig.FileDomain || getImgBase()}${item.FilePath}`
      return (
        <EasyImg
          popEnable
          defaultSrc={pictureThumb}
          src={url}
          popStyle={{ width: 180, height: 180 }}
          style={{ width: 22, height: 22, verticalAlign: 'text-top' }}
        />
      )
    })
  }
}